import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { Button, Card, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import Body from "../../ui/Body";
import { useStyles } from "../../theme/theme";




function Coupon() {

  const CouponsColomns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: 'player_id',
      headerName: 'Player Id',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'email',
      headerName: 'Email',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'qty',
      headerName: 'Quantity',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'price',
      headerName: 'Price',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'order_from',
      headerName: 'Order From',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'code',
      headerName: 'Code',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'coupon_id',
      headerName: 'Coupon Id',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'order_id',
      headerName: 'Order Id',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'expiry',
      headerName: 'Expiry',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]

  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isUsed, setIsUsed] = useState(" ");
  const [isMore, setIsMore] = useState(false);
  // const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    fetchCoupon();
  }, [isUsed, limit]);

  const fetchCoupon = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    if (page === 0 || page) {
      temp += "page=" + page + "&";
    }

    if (limit) {
      temp += "limit=" + limit + "&";
    }
    temp += "used=" + isUsed + "&";

    //console.log("-->temp-->",temp)
    axios.get(`/admin/coupons-orders/${page}/${limit}/${isUsed}`).then((res) => {
      //console.log(res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };



  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    if (page === 0 || page) {
      temp += "page=" + page + "&";
    }

    if (limit) {
      temp += "limit=" + limit + "&";
    }
    temp += "used=" + isUsed + "&";

    //console.log("-->temp-->",temp)
    axios.get(`/admin/coupons-orders/${page}/${limit}/${isUsed}`).then((res) => {
      let data = res.data.response;
      //console.log("-->",data)
      let temp = [...coupons, ...data];
      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
      // //console.log(res.data);
    });
  };

  return (
    <>
      {/* <section className={CardStyle.main}> */}

      <Body >

        <Typography style={{ color: "#646777", fontSize: "1.7rem", width: "50%" }}>Coupon</Typography>
        <Stack spacing={2} direction='row'>
          <div className={Dropdown.dropdown}>
            {coupons.length > 0 && !isMore &&
              <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>}
          </div>


          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>limit</Button>
            <div className={Dropdown.dropdown_content}>
              <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0) }}>25</a>
              <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
              <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
              <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
              <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
            </div>
          </div>



          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>Platform</Button>
            <div className={Dropdown.dropdown_content} style={{ zIndex: "10" }}>
              <a onClick={() => { setIsUsed("WordSearch"); setPage(0) }}>WordSearch</a>
              <a onClick={() => { setIsUsed("LudoUniverse"); setPage(0) }}>LudoUniverse</a>
              <a onClick={() => { setIsUsed("GamerPe"); setPage(0) }}>GamerPe</a>
            </div>
          </div>
        </Stack>

        {nodata && <section>Loading...</section>}
        <Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>


          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            // // getRowHeight={() => 'auto'}
            autoHeight
            rows={coupons}
            columns={CouponsColomns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            // pagination
            pageSize={pageSize}

            disableColumnSelector
          />
        </Paper>
        {coupons.length > 0 && !isMore && <Button variant="contained" color='info' sx={{ my: 2 }} onClick={Showmore}>More</Button>}
      </Body>




      {/* </section> */}
    </>
  );
}

export default Coupon;